module.exports = __webpack_public_path__ + "static/media/back-arrow.61719944.svg";